import { Dimmer, Loader as SemanticLoader, Segment } from "semantic-ui-react"

export default function Loader(props: any) {
  return (
    <Dimmer active inverted>
      <SemanticLoader indeterminate inverted>{props.text || ''}</SemanticLoader>
    </Dimmer>
  )
}
